import script from "./Upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./Upload.vue?vue&type=script&setup=true&lang=ts"

import "./Upload.vue?vue&type=style&index=0&id=076715bf&lang=less"

const __exports__ = script;

export default __exports__